import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import {
  TreatmentOnGoingActionButtons,
  TreatmentOnGoingTabs,
  VideoCall,
} from 'components/organisms';
import { TreatmentOnGoingProvider } from 'context';
import React from 'react';

import { Grid } from '@mui/material';
import { QueueInformationHeader } from 'components/molecules/QueueInformationHeader';

const breadcrumbs = [
  { title: 'Painel de Atendimentos' },
  { title: 'Pré Atendimento' },
  { title: 'Atendimento' },
];

const Component: React.FC = () => {
  return (
    <Grid container spacing={2}>
      <Grid item container xs={12} md={12}>
        <BreadcrumbsHeader items={breadcrumbs} />
        <QueueInformationHeader />
      </Grid>

      <Grid item container xs={12} md={12} spacing={3}>
        <Grid item sm={12} md={8} lg={9}>
          <VideoCall />
        </Grid>

        <Grid item sm={12} md={4} lg={3}>
          <TreatmentOnGoingActionButtons />
        </Grid>
      </Grid>

      <Grid item xs={12} md={12} mt={1}>
        <TreatmentOnGoingTabs />
      </Grid>
    </Grid>
  );
};

export const TreatmentOnGoingScreen: React.FC = () => (
  <TreatmentOnGoingProvider>
    <Component />
  </TreatmentOnGoingProvider>
);
